"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = __importDefault(require("react"));
const ObjWrapper = (props) => {
    const { showCenterDiv = false, children = "" } = props;
    const Wrapper = showCenterDiv
        ? styled_components_1.default.section `
        width: 100%;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
        border: 1px solid #0f0;
      `
        : styled_components_1.default.section `
        width: 100%;
        height: 100%;
        position: relative;
        transform-style: preserve-3d;
      `;
    return react_1.default.createElement(Wrapper, null, children);
};
exports.ObjWrapper = ObjWrapper;
